import script from "./PageHeader.vue?vue&type=script&lang=ts&setup=true&name=PageHeader"
export * from "./PageHeader.vue?vue&type=script&lang=ts&setup=true&name=PageHeader"

import "./PageHeader.vue?vue&type=style&index=0&id=0f2ec57d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f2ec57d"]])

export default __exports__